import type { CSSProperties, ReactNode } from "react";

export default function SectionCard({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return (
    <div className="section-card" style={style}>
      {children}
    </div>
  );
}
